
import { defineComponent } from 'vue'

interface ZStepT extends Vue {
  index: number
  showNumbers: boolean
  internalStatus: string
  align: string
}

export default defineComponent({
  name: 'ZStepper',
  props: {
    active: {
      default: 0,
      type: Number
    },
    align: {
      default: 'horizontal',
      type: String
    },
    showNumbers: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      steps: [] as ZStepT[],
      stepOffSet: 0
    }
  },
  methods: {
    updateSteps() {
      this.steps.forEach((step, index) => {
        step.index = index
        step.align = this.align
        step.showNumbers = this.showNumbers

        if (index === this.active) {
          step.internalStatus = 'active'
        } else if (index < this.active) {
          step.internalStatus = 'completed'
        } else {
          step.internalStatus = 'default'
        }
      })
    }
  },
  watch: {
    steps() {
      this.updateSteps()
    },
    active() {
      this.updateSteps()
    }
  }
})
